<template>
    <div :id="`lm-form-comment-builder-ui-${id}`" class="row">
      <LmTextInput
        :id="`prefix-${id}`"
        class="col-12 col-md-6"
        v-model="component.componentProps.commentPrefix"
        @input="$emit('input', component)"
        :label="$t('prefix')"
        :placeholder="$t('prefix')"
      />
      <LmTextInput
        :id="`comment-${id}`"
        class="col-12 col-md-6"
        v-model="component.componentProps.comment"
        @input="$emit('input', component)"
        :label="$t('comment')"
        :placeholder="$t('comment')"
      />
      <LmConditionalBuilderUi
        v-if="isVisibleCondition"
        class="col-12"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        :self="component.formObjectToSendToServerProperty"
      />
    </div>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmConditionalBuilderUi from '@/components/lmFormBuilderUi/LmConditionalBuilderUi'
export default {
  data () {
    return {
      component: {}
    }
  },
  components: {
    LmTextInput,
    LmConditionalBuilderUi
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    },
    visibilityDependOnConditions: {
      type: Object,
      default: () => ({
        isActive: false,
        conditions: []
      })
    },
    leftValueToCompareOptions: {
      type: Object,
      default: () => ({
        disabledOption: '',
        content: []
      })
    },
    id: {
      type: [String, Number],
      default: ''
    },
    showEditButton: {
      type: Boolean,
      default: false
    },
    componentData: {
      type: Object,
      default: () => ({
        componentProps: {
          comment: '',
          commentPrefix: ''
        }
      })
    }
  },
  created () {
    this.component = this.componentData
  }
}
</script>
